<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">1868 {{category_name}} Categories</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row" v-if="subCategories.length">
          <ItemCard v-for="category in subCategories" :key="category.id" :item="category" :nextLink="'/category/' + categoryId + '/sub-categories/' + category.name + '/c1868s'"></ItemCard>
        </div>
        <div class="not-found-div" v-else>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">No categories found in {{category_name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import ItemCard from '@/components/ItemCard'
export default {
  name: 'C1868SubCategories',
  components: {
    ItemCard
  },
  data () {
    return {
      subCategories: [],
      category_name: '',
      categoryId: ''
    }
  },
  mounted () {
    this.fetchPhotoImages()
  },
  methods: {
    fetchPhotoImages () {
      this.subCategories = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchC1868s', {categoryID: this.$route.params.category_id})
        .then((result) => {
          this.subCategories = result.data.c1868_sub_categories
          $('.overlay').addClass('d-none')
          this.category_name = result.data.category_name
          this.categoryId = result.data.category_id
          document.title = 'Img-Lib - ' + this.category_name + ' sub categories'
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
.not-found-div {
  height: calc(70vh - 190px);
}
@media screen and (max-width: 500px){
  .not-found-div {
    height: calc(70vh - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/C1868SubCategories.vue